import { setShowModalExportTicket } from 'features/TemplateInvoice/templateInvoiceSlice'
import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import './style.scss'

function ModalExportTicket(props) {
  const dispatch = useDispatch()
  const { exportTicketHandler, exportTicketByIdHandler } = props

  const { showModalExportTicket } = useSelector(
    (state) => state.templateInvoice,
  )

  const [exportOptions, setExportOptions] = useState({
    type: 1,
    mulTaxRate: 0,
    discount: false,
    foreignCurrency: false,
    format: 'pdf',
  })

  let handleClose = () => dispatch(setShowModalExportTicket(false))

  let handleRadioChange = (name) => (e) => {
    setExportOptions((old) => ({ ...old, [name]: e.target.value }))
  }

  return (
    <Modal
      show={showModalExportTicket}
      onHide={handleClose}
      centered
      className="ModalExportTicket"
    >
      <Modal.Header closeButton>
        <Modal.Title>Xuất mẫu vé</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p className="mb-2 font-sfpro-bold">Hình thức hiển thị mẫu vé</p>

          <div className="row mx-0 g-2 mb-5">
            <div className="col-6 px-0">
              <div className="d-flex flex-row align-items-center cursor-pointer">
                <input
                  className="mr-3 cursor-pointer"
                  type="radio"
                  id="m-template-invoice"
                  style={{ width: '1.2rem', height: '1.2rem' }}
                  name="display-form"
                  checked={exportOptions.type == 1}
                  value={1}
                  onChange={handleRadioChange('type')}
                />
                <label
                  className="m-0 font-weight-bolder cursor-pointer"
                  htmlFor="m-template-invoice"
                >
                  Vé mẫu
                </label>
              </div>
            </div>

            <div className="col-6 px-0">
              <div className="d-flex flex-row align-items-center cursor-pointer">
                <input
                  className="mr-3 cursor-pointer"
                  type="radio"
                  id="m-convert-invoice"
                  style={{ width: '1.2rem', height: '1.2rem' }}
                  name="display-form"
                  checked={exportOptions.type == 0}
                  value={0}
                  onChange={handleRadioChange('type')}
                />
                <label
                  className="m-0 font-weight-bolder cursor-pointer"
                  htmlFor="m-convert-invoice"
                >
                  Vé dạng chuyển đổi
                </label>
              </div>
            </div>
          </div>

          <p className="mt-6 mb-2 font-sfpro-bold">Chọn định dạng tệp mẫu</p>

          <div>
            <i
              className="fa-regular fa-3x fa-file-pdf mr-5 cursor-pointer"
              onClick={() =>
                setExportOptions((old) => ({ ...old, format: 'pdf' }))
              }
              style={{
                color: exportOptions.format == 'pdf' ? '#007EE9' : '#B5B5C3',
              }}
            ></i>
            <i
              className="fa-regular fa-3x fa-file-word cursor-pointer"
              onClick={() =>
                setExportOptions((old) => ({ ...old, format: 'doc' }))
              }
              style={{
                color: exportOptions.format == 'doc' ? '#007EE9' : '#B5B5C3',
              }}
            ></i>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="align-seft-end">
          <button
            className="btn btn-outline-secondary mr-4 px-8"
            onClick={handleClose}
          >
            Hủy bỏ
          </button>
          <button
            className="btn btn-danger px-8"
            onClick={() => {
              if (exportTicketHandler) {
                exportTicketHandler(exportOptions)
              } else if (exportTemplateByIdHandler) {
                let { discount, foreignCurrency, ...rest } = exportOptions
                exportTemplateByIdHandler(rest)
              }
            }}
          >
            Đồng ý
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalExportTicket
